<template>
    <section>
        <v-text-field
        label="Nombre completo"
        prepend-icon="mdi-account"
        v-model="informacionPersonal.nombre"
        ></v-text-field>
        <v-text-field
        label="Grado de estudios"
        prepend-icon="mdi-certificate"
        v-model="informacionPersonal.estudios"
        ></v-text-field>
        <v-text-field
        label="Edad"
        prepend-icon="mdi-mother-heart"
        v-model="informacionPersonal.edad"
        ></v-text-field>          
        <v-text-field
        label="Estado civil"
        prepend-icon="mdi-account-heart"
        v-model="informacionPersonal.estadoCivil"
        ></v-text-field>
        <v-textarea
        label="Escribe una pequeña descripción tuya"
        v-model="informacionPersonal.descripcion"
        ></v-textarea>
        <v-combobox
        label="Escribe tus habilidades principales"
        v-model="informacionPersonal.chips"
        chips
        clearable
        multiple>
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                @click="select"
                @click:close="quitar(item)"
              >
                <strong>{{ item }}</strong>
              </v-chip>
            </template>
        </v-combobox>
        <v-btn
          dark
          block
          color="indigo darken-4"
          elevation="2"
          @click="registrar"
        >
            Establecer inf. personal
        </v-btn>
    </section>
</template>
<script>
    export default{
        name: "InformacionPersonal",

        data:()=>({
            informacionPersonal: {
                nombre: "",
                estudios: "",
                edad: "",
                estadoCivil: "",
                descripcion: "",
                chips: []
            }
        }),

        methods: {
            quitar(item){
                this.informacionPersonal.chips.splice(this.informacionPersonal.chips.indexOf(item), 1)
            },

            registrar(){
                this.$emit("informacion", this.informacionPersonal)
            }
        }
    }
</script>